import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LivePayouts from './components/LivePayouts/LivePayouts';
import { ConfigProvider } from 'antd';
import { EventType, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { loginRequest, msalConfig } from './helpers/authConfig';
/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig);
//get initialize msalInstance
msalInstance.initialize();
const activeAccount = msalInstance.getActiveAccount();
if (!activeAccount) {
    // Account selection
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }
}
//set the account
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const authenticationResult = event.payload;
        const account = authenticationResult.account;
        msalInstance.setActiveAccount(account);
    }
});
const theme = {
    components: {
        Layout: {
            headerBg: 'transparent',
            headerPadding: '0 32px',
            headerColor: '#fff'
        }
    }
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(MsalProvider, { instance: msalInstance, children: _jsx(MsalAuthenticationTemplate, { interactionType: InteractionType.Redirect, authenticationRequest: loginRequest, children: _jsx(ConfigProvider, { theme: theme, children: _jsx(LivePayouts, {}) }) }) }) }));
